/* @flow */
import { List, Record } from 'immutable';

import type { Role } from 'modules/roles/types.js';

type CompanyObject = {
  id: number,
  name: string,
  userCount: number,
  users: any[],
};

export type UserObject = {
  id: number,
  company: CompanyObject,
  email: string,
  filters: any[],
  firstName: string,
  lastName: string,
};

export type OptionsShape = {
  query?: string,
  companyGuid?: string,
  enclaveId?: string,
  sortBy?: any[],
  sortOrder?: 'ASC' | 'DESC',
};

export const Options = Record({
  query: '',
  companyGuid: '',
  enclaveId: '',
  roleId: '',
  sortBy: ['firstName'],
  sortOrder: 'ASC',
  startPage: 0,
  pageSize: 25,
  hasNext: true,
});

type RawEnclave = { id: string, rowId: number, name: string };

export type RawUser = {
  id: number,
  guid: string,
  activationDate: number, // Timestamp
  confirmationDate: number | null, // Timestamp
  created: number, // Timestamp
  company: {
    id: number,
    enclaves: RawEnclave[],
    name: string,
  },
  email: string,
  enclaves: RawEnclave[],
  firstName: string,
  lastLogin: number,
  firstActivationDate: number,
  activationCount: number,
  lastName: string,
  mfaEnabled: boolean,
  ssoEnabled: boolean,
  deactivated: boolean,
  trialUser: boolean,
  role: Role,
  sector: string,
};

export const User = Record({
  id: null,
  guid: '',
  activationDate: null,
  confirmationDate: null, // Timestamp
  created: null, // Timestamp
  company: null,
  email: '',
  enclaves: List(),
  firstName: '',
  lastLogin: null, // Timestamp
  firstActivationDate: null, // Timestamp
  lastName: '',
  mfaEnabled: false,
  ssoEnabled: false,
  deactivated: false,
  trialUser: false,
  role: null,
  sector: '',
  activationCount: 0,
});



// WEBPACK FOOTER //
// ./src/app/modules/users/types.js